/* unplugin-vue-components disabled */import script from "./QualificationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QualificationCard.vue?vue&type=script&setup=true&lang=js"

import "./QualificationCard.vue?vue&type=style&index=0&id=d52af67e&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d52af67e"]])

export default __exports__